import api from '@/lib/api';

export const fileService = {
    getFilesByProjectId: async (projectId: string) => {
        let { data } = await api.get(`/files?projectId=${projectId}`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    UploadFile: async (fileData) => {
        const { data } = await api.post('/files/upload', fileData, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    deleteFile: async (fileId: string) => {
        const { data } = await api.delete(`/files/${fileId}`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    renameFile: async (fileId: string, name: string) => {
        const { data } = await api.patch(`/files/${fileId}`, { name }, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    updateFileCategory: async (fileId: string, category: string) => {
        const { data } = await api.patch(`/files/${fileId}`, { category }, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    // ---- Folders ----
    getFolders: async (projectId: string) => {
        const { data } = await api.get(`/projects/${projectId}/folders`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    createFolder: async (
        projectId: string,
        payload: { name: string; category: string; parentId: string | null },
    ) => {
        const { data } = await api.post(`/projects/${projectId}/folders`, payload, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    updateFolder: async (folderId: string, payload: { name?: string; parentId?: string | null; sortOrder?: number }) => {
        const { data } = await api.patch(`/folders/${folderId}`, payload, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    deleteFolder: async (folderId: string, force?: boolean) => {
        const { data } = await api.delete(`/folders/${folderId}${force ? '?force=true' : ''}`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    // ---- File placement ----
    moveFile: async (fileId: string, folderId: string | null) => {
        const { data } = await api.patch(`/files/${fileId}/folder`, { folderId }, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    moveFiles: async (fileIds: string[], folderId: string | null) => {
        const { data } = await api.patch(`/files/folder`, { fileIds, folderId }, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return data;
    },
    base64ToBlob: (base64: string, mimeType: string): Blob => {
        const byteString = atob(base64.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeType });
    }
} 